import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function AboutSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const els = sectionRef.current?.querySelectorAll('.reveal-up');
      if (els) {
        gsap.fromTo(
          els,
          { y: 40, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.8,
            stagger: 0.15,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: sectionRef.current,
              start: 'top 75%',
              toggleActions: 'play none none reverse',
            },
          }
        );
      }
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section id="sobre" ref={sectionRef} className="relative w-full py-24 md:py-32 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Text Side */}
          <div>
            <span className="reveal-up inline-block text-xs tracking-[0.2em] uppercase text-primary-500 font-label mb-4">
              Nossa História
            </span>
            <h2 className="reveal-up font-heading text-4xl md:text-5xl lg:text-6xl font-light text-foreground-900 leading-tight mb-8">
              Há mais de 12 anos<br />
              <span className="italic">realizando sonhos</span>
            </h2>
            <p className="reveal-up text-foreground-600 leading-relaxed text-base md:text-lg mb-6">
              A Ao Redor do Mundo Viagens nasceu em Fortaleza com um propósito claro: transformar o ato de viajar em uma experiência única, personalizada e inesquecível.
            </p>
            <p className="reveal-up text-foreground-600 leading-relaxed text-base md:text-lg mb-8">
              Somos mais que uma agência de viagens. Somos consultores de experiências. Cada roteiro é desenhado sob medida, cada detalhe é pensado com precisão, cada viagem é tratada como se fosse a nossa própria.
            </p>
            <div className="reveal-up flex flex-wrap gap-3">
              {['Viagens Nacionais', 'Internacionais', 'Intercâmbio', 'Cruzeiros', 'Lua de Mel', 'Seguro Viagem'].map((tag) => (
                <span
                  key={tag}
                  className="px-4 py-2 bg-background-100 border border-background-200/70 rounded-full text-sm text-foreground-600 font-light whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Image Side */}
          <div className="relative">
            <div className="reveal-up relative w-full aspect-[4/5] overflow-hidden rounded-lg">
              <img
                src="https://storage.readdy-site.link/project_files/f4c63f4d-f0a6-4026-b0ec-674f67e16aff/4d9dd69f-c50a-49b1-b7ad-4fc8c47ec710_compressed_ChatGPT-Image-28-de-jul.-de-2026-15_03_14.webp"
                alt="Consultoria de viagens Ao Redor do Mundo"
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
            </div>
            {/* Decorative accent element */}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-accent-100/60 rounded-lg -z-10"></div>
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-secondary-100/60 rounded-lg -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}